import {Component, Inject, OnInit} from '@angular/core';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';
import {DrivingSchoolService} from '../driving-school.service';
import {AlertService} from 'ngx-alerts';
import {environment} from '../../../../environments/environment';
import {finalize} from 'rxjs/operators';
import {NgxSpinnerService} from 'ngx-spinner';
import {DashboardService} from '../../../services/dashboard.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Browser} from 'leaflet';
import win = Browser.win;
import {IDropdownSettings} from 'ng-multiselect-dropdown/multiselect.model';

@Component({
  selector: 'app-driving-school-profile',
  templateUrl: './driving-school-profile.component.html',
  styleUrls: ['./driving-school-profile.component.scss']
})
export class DrivingSchoolProfileComponent implements OnInit {

  userDetails: any;
  loggedInUserData: any;
  selectedFile: any;

  businessProfileForm: FormGroup;
  dataForm: FormGroup;
  isShowIFSCError: boolean = false;
  dataFormSubmitted = false;


  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  websiteLink: any = 'https://gypsee.ai/ds/dilipdrivingschool';
  public userType = this.storage.get('gs-loggedInUserType');

  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService, private drivingSchoolService: DrivingSchoolService,
              private alertService: AlertService, private spinner: NgxSpinnerService,
              private dashboardService: DashboardService, private fb: FormBuilder) {
    this.loggedInUserData = storage.get('gs-loggedInUserData');
  }

  ngOnInit(): void {
    this.buildDataForm();
    this.getUserDetails();
    this.getUserBankAccountDetails();
    this.dropdownList = [
      {timing: '6Am-7Am'},
      {timing: '7Am-8Am'},
      {timing: '8Am-9Am'},
      {timing: '10Am-11Am'},
      {timing: '11Am-12Pm'},
      {timing: '1Pm-2Pm'},
      {timing: '2Pm-3Pm'},
      {timing: '3Pm-4Pm'},
      {timing: '4Pm-5Pm'},
      {timing: '5Pm-6Pm'},
      {timing: '6Pm-7Pm'},
      {timing: '7Pm-8Pm'},
      {timing: '8Pm-9Pm'},
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'timing',
      textField: 'timing',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }

  private getUserDetails() {
    this.spinner.show();
    this.drivingSchoolService.getUserDetails(this.loggedInUserData.userId, {
      isWallet: true,
      isBusinessProfileDetails: true
    }).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.userDetails = res.user;
        if (this.userDetails.businessProfile) {
          this.populateBusinessProfileData(this.userDetails.businessProfile);
        }
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );

  }

  getAddress(userAddress: any) {
    return userAddress.addressLineOne + ' ' + userAddress.addressLineTwo + ' ' + userAddress.city + ' ' + userAddress.state + ' ' + userAddress.pincode;
  }

  onImageUpload(event: any) {
    const files = event.target.files;
    if (files) {
      for (let file of files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedFile = {fileName: file.name, fileContent: e.target.result};
          console.log(this.selectedFile.fileContent);
        };
        reader.readAsDataURL(file);

        console.log(event.target.value);
      }
    }

  }

  onSubmitClick() {
    if (this.selectedFile && this.selectedFile.fileContent) {
      let payload = {
        file: this.selectedFile.fileContent,
        upload_preset: environment.cloudinary.userImageUploadPreset,
        'api_key': environment.cloudinary.apiKey,
        'api_secret': environment.cloudinary.apiSecret,
      };
      this.spinner.show();
      this.dashboardService.uploadToCloudinary(payload).pipe(finalize(() => this.spinner.hide())).subscribe(
        (res: any) => {
          console.log(JSON.stringify(res));
          this.businessProfileForm.get('imageUrl').setValue(res.secure_url);
          this.selectedFile = undefined;
          this.updateBusinessProfileDetails();
        }, error => {
          this.alertService.danger(error['message']);
          console.error(error);
        }
      );
    } else {
      this.updateBusinessProfileDetails();
    }
  }

  private buildDataForm() {
    this.businessProfileForm = this.fb.group({
      id: [''],
      businessName: ['', Validators.required],
      contactNumber: ['', Validators.required],
      address: ['', Validators.required],
      imageUrl: [''],
    });
    this.dataForm = this.fb.group({
      accountNo: ['', Validators.required],
      accountHoldersName: ['', Validators.required],
      ifscCode: ['', Validators.required],
      bankName: ['', Validators.required],
      branchName: ['', Validators.required],
      gstNo: ['']
    });
  }

  private updateBusinessProfileDetails() {
    this.spinner.show();
    this.drivingSchoolService.addUpdateBusinessProfileDetails(this.userDetails.userId, this.businessProfileForm.value)
      .pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.alertService.success(res.message);
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );

  }

  private populateBusinessProfileData(businessProfile: any) {
    this.businessProfileForm.get('id').setValue(businessProfile.id);
    this.businessProfileForm.get('businessName').setValue(businessProfile.businessName);
    this.businessProfileForm.get('contactNumber').setValue(businessProfile.contactNumber);
    this.businessProfileForm.get('address').setValue(businessProfile.address);
    this.businessProfileForm.get('imageUrl').setValue(businessProfile.imageUrl);
  }

  getOS() {
    let userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  onRaiseTickerClick() {
    let platform = this.getOS();
    if (platform == 'Android' || platform == 'Mac OS' || platform == 'iOS') {
      let link = 'mailto:hello@getfuelshine.com?subject=Technical Assistance Request&body=' + this.userDetails?.userFullName + '%0d%0a ' +
        this.userDetails?.userPhoneNumber + '%0d%0aDriving School%0d%0a %0d%0a ';
      let win = window.open(link, '_blank');
      win.focus();
      setTimeout(() => win?.close(), 2000);
    } else {
      let link = 'https://mail.google.com/mail/u/' + this.userDetails.userEmail +
        '/?view=cm&fs=1&to=hello@getfuelshine.com&su=Technical Assistance Request&body=' + this.userDetails?.userFullName + '%0d%0a ' +
        this.userDetails?.userPhoneNumber + '%0d%0aDriving School%0d%0a %0d%0a ';
      console.log(link);
      let win = window.open(link, '_blank');
      win.focus();
    }
  }

  onIFSCChange() {
    console.log(this.dataForm.value.ifscCode);
    if (this.dataForm.value.ifscCode) {
      this.spinner.show();
      this.dashboardService.fetchBankDetailsByIFSCCode(this.dataForm.value.ifscCode).pipe(finalize(() => this.spinner.hide())).subscribe(
        (res: any) => {
          console.log(res);
          this.isShowIFSCError = false;
          this.dataForm.get('bankName').setValue(res.BANK);
          this.dataForm.get('branchName').setValue(res.BRANCH);
        }, error => {
          console.error(error);
          this.isShowIFSCError = true;
          this.alertService.danger(error);
        }
      );
    }
  }

  onKeyPress(ev: any) {
    if (ev.toLowerCase() == 'enter') {
      this.onIFSCChange();
    }
  }

  onAccountDetailsUpdateClick() {
    this.dataFormSubmitted = true;
    if (this.dataForm.invalid) {
      this.alertService.danger('Please add all required details');
      return;
    }
    this.spinner.show();
    this.drivingSchoolService.addUpdateUserBankDetails(this.loggedInUserData.userId, this.dataForm.value).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.alertService.success(res['message']);
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  private getUserBankAccountDetails() {
    this.drivingSchoolService.getUserBankDetails(this.loggedInUserData.userId).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        let accountDetails = res.accountDetails;
        this.dataForm.get('accountNo').setValue(accountDetails.accountNo);
        this.dataForm.get('accountHoldersName').setValue(accountDetails.accountHoldersName);
        this.dataForm.get('ifscCode').setValue(accountDetails.ifscCode);
        this.dataForm.get('bankName').setValue(accountDetails.bankName);
        this.dataForm.get('branchName').setValue(accountDetails.branchName);
        this.dataForm.get('gstNo').setValue(accountDetails.gstNo);
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }
}
